import { isString } from 'lodash-es'
import { URL_PARSING_BASE } from 'lib/consts/hostnames'

export const isNextUrlValid = (next: Maybe<string>): next is string => {
  if (!isString(next) || !next.startsWith('/') || next.startsWith('//')) {
    return false
  }

  try {
    return new URL(next, URL_PARSING_BASE).origin === URL_PARSING_BASE
  } catch {
    return false
  }
}
